<template>
    <div id="react-container">
        <div data-reactroot=""><!-- react-empty: 2 -->
            <div>
                <div class="sc-kafWEX hvoxeo">
                    <div class="product-container">
                        <div
                            style="box-sizing: border-box; min-height: 1px; position: relative; display: flex; flex-direction: column; width: 100%; flex: 0 0 100%; max-width: 100%; margin-left: 0%; right: auto; left: auto;">
                            <div class="sc-jzgbtB diEiwz sc-cmTdod dzlHoR">
                                <section class="sc-bnXvFD fNhWMg sc-dnqmqq NinWN" @click="toggleFavorite">
                                    <svg class="sc-iwsKbI kOIKqN sc-htoDjs" :class="isFavorited ? 'yEigr2' : 'yEigr'"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="18 18 60 60" width="24px"
                                        height="24px">
                                        <g>
                                            <path
                                                d="M48,71.6c-0.5,0-1-0.2-1.4-0.6L27.5,52.5c-0.2-0.2-0.5-0.4-0.8-0.8c-0.4-0.4-0.9-1-1.7-2   c-0.8-1-1.5-2-2.1-3c-0.6-1-1.2-2.3-1.6-3.7c-0.5-1.5-0.7-2.9-0.7-4.2c0-4.5,1.3-8,3.9-10.6s6.2-3.8,10.8-3.8   c1.3,0,2.6,0.2,3.9,0.7c1.3,0.4,2.5,1,3.7,1.8c1.1,0.7,2.1,1.4,2.9,2.1c0.8,0.7,1.6,1.4,2.3,2.1c0.7-0.7,1.5-1.4,2.3-2.1   c0.8-0.7,1.8-1.4,2.9-2.1c1.1-0.7,2.4-1.3,3.7-1.8c1.3-0.4,2.6-0.7,3.9-0.7c4.6,0,8.2,1.3,10.8,3.8s3.9,6.1,3.9,10.6   c0,4.5-2.3,9.1-7,13.8L49.4,71C49,71.4,48.5,71.6,48,71.6z">
                                            </path>
                                        </g>
                                    </svg>
                                </section>
                                <div class="product-detail-row">
                                    <div class="product-image-col">
                                        <div>
                                            <div class="sc-dqBHgY kzmGcl">
                                                <section class="sc-gxMtzJ fckrYL" id="product-media"
                                                    @touchstart="handleTouchStart" @touchmove="handleTouchMove"
                                                    @touchend="handleTouchEnd">
                                                    <div v-for="(image, index) in images" :key="index"
                                                        class="sc-bYSBpT jXdwPZ" :id="`img-${index}`">
                                                        <img class="sc-elJkPf hMFySe" :src="image">
                                                    </div>
                                                    <div class="sc-jtRfpW btSFVV">
                                                        <div :class="{ noShow: isFirstImage }" @click="prevImage">
                                                            <i class="fa fa-angle-left"></i>
                                                        </div>
                                                        <div :class="{ noShow: isLastImage }" @click="nextImage">
                                                            <i class="fa fa-angle-right"></i>
                                                        </div>
                                                    </div>
                                                    <div class="sc-kTUwUJ jxDVvh">
                                                        <div>{{ currentImageDisplay }}</div>
                                                    </div>
                                                </section>
                                            </div>
                                            <section class="sc-iyvyFf fPkgfg">
                                                <div v-for="(image, index) in images" :key="index"
                                                    class="sc-dfVpRl juqvNl"
                                                    :class="{ active: currentImageIndex === index }"
                                                    @click="goToImage(index)">
                                                    <img class="sc-gzOgki gCrnRY" :src="image">
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                    <div class="product-info-col">
                                        <div>
                                            <h3 class="product-name"
                                                style="color: rgb(0, 0, 0); font-size: 2.1875rem; font-weight: 500; margin-bottom: 0px;">
                                                {{ productData?.title || 'Loading...' }}
                                            </h3>
                                            <div class="sc-fYiAbW NJgzn">
                                                <div class="retail-price">${{ productData?.originprice || '0.00' }}
                                                </div>
                                                <div class="sc-krvtoX hxWNLV"><span
                                                        style="color: rgb(0, 0, 0); font-size: 2.5rem; font-weight: bold; margin-right: 10px;">${{
                                                            productData?.price || '0.00' }} <span style="font-size: 16px;font-weight: 400;">after cash back</span></span>
                                                </div>
                                            </div>
                                            <div class="sc-dUjcNx fcmNQk sc-fOKMvo gTkNMg"><span><b>Seller:
                                                    </b>{{ productData?.seller || 'Unknown' }}</span>
                                            </div>
                                            <div class="sc-fOKMvo gTkNMg">
                                                <div v-if="productData?.primeswitch === 1">
                                                    <section class="sc-chPdSV lbhUOd"><svg class="sc-kAzzGY cSPCYd"
                                                            id="288281" height="24" viewBox="0 0 24 24" width="24"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g transform="translate(-1577.9 -248.353)">
                                                                <g>
                                                                    <rect height="24" rx="11.729"
                                                                        transform="translate(1577.9 248.353)"
                                                                        width="24"></rect>
                                                                </g>
                                                                <g>
                                                                    <path
                                                                        d="M1587.662,264.374l-3.08-3.2a.59.59,0,0,1,.85-.818l2.255,2.344,6.688-6.533a.589.589,0,1,1,.824.843Z"
                                                                        fill="#f2f2f2"></path>
                                                                </g>
                                                            </g>
                                                        </svg><span> prime</span></section>
                                                </div>
                                            </div>
                                            <p v-if="!isLoggedIn" class="bg-danger"
                                                style="color: rgb(238, 238, 238); margin-top: 30px; padding: 5px; text-align: center;">
                                                <i class="fa fa-warning "></i>
                                                Sign in to snag this deal.
                                            </p>
                                            <div>
                                                <div class="sc-iujRgT gBwkYC">
                                                    <section class="sc-exAgwC izpgKW"><img alt="discount-icon"
                                                            src="@/assets/images/header/discount.svg"
                                                            class="sc-GMQeP ggmeuU sc-gqPbQI cGxNOm"><span
                                                            class="sc-cQFLBn dvuMXO">{{ productData?.discount || '0%'
                                                            }} off</span></section>
                                                    <section class="sc-exAgwC izpgKW"><img alt="box-icon"
                                                            src="@/assets/images/header/box.svg"
                                                            class="sc-hORach jyQHCJ sc-hMFtBS gknIvK"><span
                                                            class="sc-cQFLBn dvuMXO">{{ productData?.stock || '0' }} in
                                                            stock</span></section>
                                                    <section class="sc-exAgwC izpgKW"><img alt="clock-icon"
                                                            src="@/assets/images/header/clock.svg"
                                                            class="sc-bMVAic fHsNUo sc-cLQEGU kYxfiv"><span
                                                            class="sc-cQFLBn dvuMXO">{{ productData?.etime || '0'
                                                            }} left</span></section>
                                                    <!-- <section class="sc-exAgwC izpgKW"><svg class="sc-bAeIUo gzqtwP"
                                                            viewBox="0 0 1024 1024">
                                                            <path class="cursor-pointer "
                                                                d="M800.285 111.242h-576.57c-51.147 0-99.988 20.942-137.189 55.798-34.895 37.201-55.798 86.042-55.798 134.843v557.966c0 23.248 13.946 44.19 37.201 51.147 4.651 2.345 11.64 2.345 18.597 0 16.291 0 32.55-6.996 41.845-18.597l181.34-199.937c20.942-23.248 18.597-58.143-4.651-79.046s-58.143-18.597-79.046 4.651l-86.042 95.337v-411.521c0-20.941 9.302-41.844 25.593-55.797 13.946-16.291 34.895-23.248 58.143-23.248h576.57c23.248 0 44.19 6.996 60.449 23.248 13.946 13.946 23.248 34.895 23.248 55.797v197.631c0 44.19-34.895 79.046-79.046 79.046h-267.375c-30.244 0-55.798 25.593-55.798 55.798 0 32.55 25.593 55.798 55.798 55.798h262.731c106.945 0 192.98-83.697 192.98-190.642v-197.631c0-48.84-20.942-97.642-55.798-134.843-37.201-34.895-86.042-55.798-137.189-55.798z"
                                                                fill="inherit" stroke="inherit" stroke-width="inherit"
                                                                stroke-linejoin="inherit" stroke-linecap="inherit"
                                                                stroke-miterlimit="inherit" opacity="1"></path>
                                                        </svg><span class="sc-cQFLBn dvuMXO">Asks for review</span>
                                                    </section> -->
                                                    <section class="sc-exAgwC izpgKW"><svg class="sc-bAeIUo gzqtwP"
                                                            viewBox="0 0 1024 1024">
                                                        </svg><span class="sc-cQFLBn dvuMXO">${{ productData?.cashbackmoney || '0' }} cash back</span>
                                                    </section>
                                                </div>
                                            </div>
                                            <div
                                                style="align-items: center; display: flex; margin-bottom: 20px;gap: 10px; margin-top: 30px;">
                                                <button v-if="!isLoggedIn" class="sc-bXGyLb eppWtj sc-daURTG kduZGZ"
                                                    id="snag-it" @click="showLoginModal">Log
                                                    in</button>
                                                <!-- <button v-if="isLoggedIn" class="sc-bXGyLb eppWtj sc-daURTG kduZGZ"
                                                    id="snag-it" @click="handleLink">Purchase link</button> -->
                                                    <!-- 积分获取链接 -->
                                                     <button class="sc-bXGyLb eppWtj sc-daURTG kduZGZ" @click="goToConfirmSnag">Get Deal</button>
                                                    <!-- <button class="sc-bXGyLb eppWtj sc-daURTG kduZGZ" @click="showContactModal">Get Deal</button> -->
                                                <!-- @click="showContactModal" -->
                                                    <a
                                                    href="javascript:void(0)"
                                                    @click="handleLink"
                                                    id="view-amazon"
                                                    class="sc-cbkKFq hgRRyp btn btn-default btn-block">
                                                    <svg height="32.532px" viewBox="0 0 6.776 32.532" width="49"
                                                        xmlns="http://www.w3.org/2000/svg" class="sc-lkqHmb hNxRHe">
                                                        <g transform="translate(-473 -543.217)">
                                                            <g transform="translate(-44 -2)">
                                                                <path
                                                                    d="M536.669,570.953c0-.112,0-.223,0-.335a.625.625,0,0,0-.441-.642,7.275,7.275,0,0,0-1.8-.312,3.033,3.033,0,0,0-.665.036c-.473.059-.946.119-1.415.2a4.91,4.91,0,0,0-2.058.84,1.151,1.151,0,0,0-.276.347c-.057.092-.015.167.093.2a.647.647,0,0,0,.223.017c.275-.032.547-.079.821-.107.532-.054,1.063-.111,1.6-.141a6.7,6.7,0,0,1,1,.021,3.962,3.962,0,0,1,.83.163.58.58,0,0,1,.461.666,5.075,5.075,0,0,1-.1.843,14.582,14.582,0,0,1-.771,2.362c-.111.281-.229.558-.339.839a.223.223,0,0,0,.043.269.249.249,0,0,0,.29.045.765.765,0,0,0,.2-.127c.2-.192.4-.381.584-.589a6.859,6.859,0,0,0,1.264-2.277A6.531,6.531,0,0,0,536.669,570.953Z"
                                                                    fill="#000"></path>
                                                                <path
                                                                    d="M520.706,545.217c.142.015.283.032.425.044a8.777,8.777,0,0,1,3.12.8,5.768,5.768,0,0,1,2.577,2.372,2.039,2.039,0,0,1,.2.462c.134.491.271.983.368,1.481a6.464,6.464,0,0,1,.066.935c.012.262.017.524.017.786q0,3.793,0,7.586a4.824,4.824,0,0,0,.59,2.378,8.713,8.713,0,0,0,.6.843c.086.119.186.229.264.354a1.809,1.809,0,0,1,.185.374.5.5,0,0,1-.171.572q-1.482,1.285-2.966,2.572a.92.92,0,0,1-1.094-.012,10.9,10.9,0,0,1-1.944-2.24c-.042-.066-.094-.126-.147-.2-.093.1-.178.189-.265.278a9.319,9.319,0,0,1-2.24,1.756,6.221,6.221,0,0,1-2.1.65,11.39,11.39,0,0,1-1.979.1,5.575,5.575,0,0,1-4.009-1.7,4.887,4.887,0,0,1-1.239-2.331,7.72,7.72,0,0,1,.111-4.129,6.287,6.287,0,0,1,3.23-3.741,11.8,11.8,0,0,1,2.975-1.019,20.992,20.992,0,0,1,2.811-.416c.655-.053,1.309-.116,1.973-.176,0-.034.007-.069.006-.1-.016-.571-.016-1.144-.056-1.713a5.538,5.538,0,0,0-.177-1.005,1.847,1.847,0,0,0-1.379-1.354,3.4,3.4,0,0,0-3.313.725,2.583,2.583,0,0,0-.785,1.4,1.885,1.885,0,0,1-.147.424.635.635,0,0,1-.707.348c-.624-.08-1.248-.151-1.872-.227-.546-.066-1.091-.129-1.636-.2a.608.608,0,0,1-.582-.463,1.372,1.372,0,0,1,.032-.436,7.081,7.081,0,0,1,.938-2.448,6.017,6.017,0,0,1,2.2-2.04,9.857,9.857,0,0,1,3.391-1.163c.3-.046.613-.074.92-.111a.571.571,0,0,0,.082-.02Zm1.377,11.46c-.038,0-.067,0-.1,0a14.534,14.534,0,0,0-2.053.108,5.112,5.112,0,0,0-1.908.631,3.13,3.13,0,0,0-1.418,1.608,4.2,4.2,0,0,0-.131,2.592,2.338,2.338,0,0,0,.818,1.287,2.13,2.13,0,0,0,1.639.431,2.888,2.888,0,0,0,1.689-.828,4.177,4.177,0,0,0,.858-1.232,5.765,5.765,0,0,0,.593-2.427c.017-.7.01-1.409.013-2.114C522.088,556.715,522.085,556.7,522.083,556.677Z"
                                                                    fill="#000"></path>
                                                                <path
                                                                    d="M500.894,570.619c.026-.046.05-.094.079-.138a.236.236,0,0,1,.323-.11c.186.085.363.189.541.29a34.6,34.6,0,0,0,8.24,3.359,33.351,33.351,0,0,0,3.336.7c.63.1,1.264.171,1.9.244.409.047.82.079,1.232.107s.831.048,1.246.066c.3.012.611.014.916.022.172.005.344.018.516.017.37,0,.741-.006,1.11-.022.509-.022,1.018-.045,1.526-.087,1.183-.1,2.358-.251,3.526-.466a36.158,36.158,0,0,0,6.495-1.847c.271-.105.535-.227.8-.343a.567.567,0,0,1,.785.218.385.385,0,0,1-.061.536,4.145,4.145,0,0,1-.472.357,23.433,23.433,0,0,1-6.966,3.191,25.947,25.947,0,0,1-3.128.692c-.585.09-1.171.166-1.759.232-.352.04-.708.056-1.062.07-.506.02-1.013.043-1.519.039-.541-.005-1.084-.024-1.624-.065-.625-.048-1.25-.111-1.871-.2a24.863,24.863,0,0,1-3.265-.67,26.342,26.342,0,0,1-4.383-1.646,25.573,25.573,0,0,1-4.606-2.825c-.571-.441-1.115-.918-1.666-1.386a1.354,1.354,0,0,1-.189-.256Z"
                                                                    fill="#ffa200"></path>
                                                                <path
                                                                    d="M536.669,570.953a6.531,6.531,0,0,1-.453,2.311,6.859,6.859,0,0,1-1.264,2.277c-.182.208-.385.4-.584.589a.765.765,0,0,1-.2.127.249.249,0,0,1-.29-.045.223.223,0,0,1-.043-.269c.11-.281.228-.558.339-.839a14.582,14.582,0,0,0,.771-2.362,5.075,5.075,0,0,0,.1-.843.58.58,0,0,0-.461-.666,3.962,3.962,0,0,0-.83-.163,6.7,6.7,0,0,0-1-.021c-.533.03-1.064.087-1.6.141-.274.028-.546.075-.821.107a.647.647,0,0,1-.223-.017c-.108-.028-.15-.1-.093-.2a1.151,1.151,0,0,1,.276-.347,4.91,4.91,0,0,1,2.058-.84c.469-.079.942-.139,1.415-.2a3.033,3.033,0,0,1,.665-.036,7.275,7.275,0,0,1,1.8.312.625.625,0,0,1,.441.642C536.67,570.73,536.669,570.841,536.669,570.953Z"
                                                                    fill="#ffa200"></path>
                                                            </g>
                                                        </g>
                                                    </svg></a>
                                            </div>
                                            <!-- <div class="sc-eLExRp hwPjrI">
                                                <a href="#/offers?category=home_garden_tools"
                                                    style="color: rgb(0, 0, 0);">Home, Garden &amp; Tools</a>
                                            </div> -->
                                            <div class="sc-gHboQg eSybho">Shout it:<span
                                                    style="display: flex; align-items: center;"><span
                                                        style="margin: 0px 5px 5px;">
                                                        <!-- https://www.facebook.com/sharer/sharer.php?u=http://snag.it/568711 -->
                                                        <button
                                                            @click="handleThirdParty(productData.urllink2)"
                                                            class="social-button facebook"
                                                            style="background: none; border: none; font-size: 16px; padding: 0px; cursor: pointer;"><img
                                                                alt="" src="@/assets/images/header/facebook.svg"
                                                                style="margin-top: 0px; width: 24px; object-fit: cover;"></button></span><span
                                                        style="margin: 0px 5px 5px;">
                                                        <button
                                                        @click="handleThirdParty(productData.urllink3)"
                                                            class="social-button twitter"
                                                            style="background: none; border: none; font-size: 16px; padding: 0px;"><img
                                                                alt="" src="@/assets/images/header/twitter.svg"
                                                                style="margin-top: 6px; width: 43px; object-fit: cover;"></button></span><span
                                                        style="margin: 0px 5px 5px;">
                                                        <button
                                                            @click="handleThirdParty(productData.urllink4)"
                                                            class="social-button pinterest"
                                                            style="background: none; border: none; font-size: 16px; padding: 0px;"><img
                                                                alt="" src="@/assets/images/header/pinterest.svg"
                                                                style="margin-top: 0px; width: 24px; object-fit: cover;"></button></span><span
                                                        style="margin: 0px 5px 5px; position: relative;display: flex;align-items: center;gap: 6px;">
                                                        
                                                        <button class="social-button link" @click="toggleLinkInput"
                                                            style="background: none; border: none; color: rgb(255, 164, 33); padding: 0px; margin: 5px; cursor: pointer;">
                                                            <img alt="" src="@/assets/images/header/link.svg"
                                                                style="width: 23px;">
                                                        </button>
                                                        <div v-if="showLinkInput" class="link-input-wrapper form-group">
                                                            
                                                            <input type="text" :value="currentUrl" readonly id=""
                                                                class="form-control" style="margin-top: 10px;">
                                                        </div>
                                                    </span></span></div>
                                            <div name="Description" title="Description">
                                                <div style="color: rgb(0, 0, 0); font-size: 18px; margin-bottom: 20px;">
                                                    <div v-html="productData.content">
                                                        <!-- <div v-if="!isDescriptionExpanded">
                                                            <span>{{ (productData?.content || '').substring(0, 100)
                                                                }}...</span>
                                                            <a href="javascript:void(0)" @click="toggleDescription"
                                                                class="read-more-btns">Read more</a>
                                                        </div> -->
                                                        <!-- <div v-else>
                                                            <span>{{ productData?.content || 'No description available'
                                                                }}</span>
                                                            <a href="javascript:void(0)" @click="toggleDescription"
                                                                class="read-more-btns">Hide</a>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 评论区域 -->
                        <div class="review-section">
                            <div class="review-header">
                                <h3 class="review-title">Customer Reviews ({{ reviews.length }})</h3>
                                <div class="review-toggle" @click="toggleReviews">
                                    <i :class="showReviews ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                                    <span>{{ showReviews ? 'Hide Reviews' : 'Show Reviews' }}</span>
                                </div>
                            </div>

                            <!-- 已有评论列表 -->
                            <transition name="slide-fade">
                                <div v-if="showReviews" class="reviews-list">
                                    <!-- 有评论时显示 -->
                                    <div v-if="reviews && reviews.length > 0">
                                        <div v-for="review in reviews" :key="review.id" class="review-item">
                                            <div class="review-user-info">
                                                <div class="user-avatar">{{ review.userName ? review.userName.charAt(0)
                                                    : 'U' }}</div>
                                                <div class="user-details">
                                                    <div class="user-name">{{ review.userName || 'Anonymous' }}</div>
                                                    <div class="review-date">{{ review.date }}</div>
                                                </div>
                                            </div>
                                            <div class="review-rating">
                                                <i v-for="star in 5" :key="star" class="fa fa-star"
                                                    :class="{ 'star-filled': star <= review.rating, 'star-empty': star > review.rating }"></i>
                                            </div>
                                            <div class="review-text">{{ review.text }}</div>
                                            <div v-if="review.images && review.images.length > 0" class="review-images">
                                                <img v-for="(img, index) in review.images" :key="index" :src="img"
                                                    alt="Review image" class="review-image"
                                                    @click="openImagePreview(img)">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 无评论时显示 -->
                                    <div v-else class="no-reviews">
                                        <i class="fa fa-comments-o"
                                            style="font-size: 48px; color: #ccc; margin-bottom: 10px;"></i>
                                        <p>No reviews yet. Be the first to leave one!</p>
                                    </div>
                                </div>
                            </transition>

                            <!-- 添加评论表单 -->
                            <div class="add-review-section">
                                <h4 class="add-review-title">Write a Review</h4>
                                <div class="rating-input">
                                    <span class="rating-label">Your Rating:</span>
                                    <div class="star-rating">
                                        <i v-for="star in 5" :key="star" class="fa fa-star"
                                            :class="{ 'star-filled': star <= newReview.rating, 'star-empty': star > newReview.rating }"
                                            @click="setRating(star)" @mouseover="hoverRating = star"
                                            @mouseleave="hoverRating = 0"
                                            :style="{ color: (hoverRating >= star || newReview.rating >= star) ? '#ffc107' : '#e0e0e0' }"></i>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Your Review:</label>
                                    <textarea v-model="newReview.text" class="form-control review-textarea"
                                        placeholder="Share your experience with this product..." rows="4"></textarea>
                                </div>
                                <div class="form-group">
                                    <label>Add Photos (Optional):</label>
                                    <div class="image-upload-area">
                                        <input type="file" ref="imageInput" @change="handleImageUpload" accept="image/*"
                                            multiple style="display: none;">
                                        <button type="button" class="btn-upload-image"
                                            @click="$refs.imageInput.click()">
                                            <i class="fa fa-camera"></i>
                                            <span>Upload Images</span>
                                        </button>
                                        <div v-if="newReview.images.length > 0" class="preview-images">
                                            <div v-for="(img, index) in newReview.images" :key="index"
                                                class="preview-image-wrapper">
                                                <img :src="img" alt="Preview" class="preview-image">
                                                <button type="button" class="btn-remove-image"
                                                    @click="removeImage(index)">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button class="btn-submit-review" @click="submitReview">
                                    Submit Review
                                </button>
                            </div>
                        </div>

                        <div class="sc-fhYwyz eELPGX">
                            <h3 class="sc-gFaPwZ section-header text-center dDUrGZ">Related Deals</h3>
                            <div class="sc-dymIpo fwrjDL" color="#FFC200"></div>
                        </div>
                        <div style="padding-top: 20px;">
                            <section>
                                <div class="">
                                    <section class="sc-fAjcbJ dFKDPr">
                                        <ProductCard v-for="product in relatedProducts" :key="product.id"
                                            :product="product" class="sc-jlyJG" />
                                    </section>
                                </div>
                            </section>
                        </div><!-- react-empty: 2306 -->
                    </div>
                    <div style="display: table; clear: both;"><span style="display: none;">&nbsp;</span></div>
                </div>
            </div>
        </div>

        <!-- 联系管理员弹窗 -->
        <transition name="contact-modal">
            <div v-if="showContactAdminModal" class="contact-overlay" @click="closeContactModal">
                <div class="contact-box" @click.stop>
                    <div class="contact-box-header">
                        <div class="contact-box-icon">
                            <i class="fa fa-headphones"></i>
                            
                        </div>
                        <h4 class="contact-box-title">Contact Administrator</h4>
                        <button type="button" class="close-btn" @click="closeContactModal">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="contact-box-body">
                        <p class="info-text">To earn points, please contact our administrator:</p>
                        <a :href="'https://wa.me/' + contactPhone.replace(/[^0-9]/g, '')" class="contact-item" target="_blank" v-if="contactPhone">
                            <!-- <i class="fa fa-phone"></i> -->
                            <img style="width: 20px;" src="@/assets/images/phone.webp" alt="">
                            <span class="contact-label">WhatsApp</span>
                            <a class="contact-value">{{ contactPhone }}</a>
                        </a>
                        <div class="contact-item" v-if="contactEmail">
                            <i class="fa fa-envelope"></i>
                            <span class="contact-label">Email</span>
                            <a class="contact-value">{{ contactEmail }}</a>
                        </div>
                    </div>
                    <div class="contact-box-footer">
                        <button type="button" class="btn-close-modal" @click="closeContactModal">Close</button>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue'
import { productApi, commonApi } from '@/api'
import userStore from '@/store/user.js'

export default {
    components: {
        ProductCard
    },
    data() {
        return {
            loading: false,
            productData: null,
            currentImageIndex: 0,
            isDescriptionExpanded: false,
            showLinkInput: false,
            showReviews: false,
            hoverRating: 0,
            isFavorited: false,
            userStore: userStore.state,
            showContactAdminModal: false, // 联系管理员弹窗
            contactPhone: '',
            contactEmail: '',
            // 触摸滑动相关
            touchStartX: 0,
            touchEndX: 0,
            touchStartY: 0,
            touchEndY: 0,
            // 新评论数据
            newReview: {
                rating: 0,
                text: '',
                images: [],
                uploadedImageUrls: [] // 存储上传后的图片URL
            },
            // 已有评论数据
            reviews: [
                
            ],
            images: [
            ],
            relatedProducts: [],
            reviews: [
                
            ]
        }
    },
    computed: {
        isLoggedIn() {
            return this.userStore.isLoggedIn
        },
        totalImages() {
            return this.images.length
        },
        currentImageDisplay() {
            return `${this.currentImageIndex + 1}/${this.totalImages}`
        },
        isFirstImage() {
            return this.currentImageIndex === 0
        },
        isLastImage() {
            return this.currentImageIndex === this.totalImages - 1
        },
        currentUrl() {
            return window.location.href
        },
        cashBack() {
            const origin = parseFloat(this.productData?.originprice) || 0
            const current = parseFloat(this.productData?.price) || 0
            const diff = origin - current
            return diff > 0 ? diff.toFixed(2) : '0.00'
        },
        averageRating() {
            if (this.reviews.length === 0) return 0
            const sum = this.reviews.reduce((acc, review) => acc + review.rating, 0)
            return (sum / this.reviews.length).toFixed(1)
        }
    },
    async mounted() {
        // 监听键盘事件
        window.addEventListener('keydown', this.handleKeyPress)
        // 加载配置信息（电话、邮箱）
        this.loadConfig()
        // 加载产品详情
        await this.loadProductDetail()
        // 加载推荐产品
        await this.loadRelatedProducts()
        // 核心API：scrollTo 实现平滑滚动
        window.scrollTo({
            top: 0, // 滚动到页面顶部
            behavior: 'smooth' // 平滑滚动，可选值：auto(瞬间跳转)/smooth(平滑)
        });
    },
    watch: {
        $route: {
            async handler() {
                // 核心API：scrollTo 实现平滑滚动
                window.scrollTo({
                    top: 0, // 滚动到页面顶部
                    behavior: 'smooth' // 平滑滚动，可选值：auto(瞬间跳转)/smooth(平滑)
                });
                // 加载产品详情
                await this.loadProductDetail()
                // 加载推荐产品
                await this.loadRelatedProducts()
            },
            deep: true
        }
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeyPress)
    },
    methods: {
        //点击跳转第三方
        handleThirdParty(url) {
            if (!url) {
                this.$toast('No share link available')
                return
            }
            window.open(url, '_blank')
        },
        // 加载配置信息
        async loadConfig() {
            try {
                const res = await commonApi.getConfig()
                this.contactPhone = res.data.phone || ''
                this.contactEmail = res.data.email || ''
            } catch (e) {
                console.error('Failed to load config:', e)
            }
        },
        async loadConfig() {
            try {
                const res = await commonApi.getConfig()
                this.contactPhone = res.data.phone || ''
                this.contactEmail = res.data.email || ''
            } catch (e) {
                console.error('Failed to load config:', e)
            }
        },
        // 显示联系管理员弹窗
        showContactModal() {
            this.showContactAdminModal = true
        },
        // 跳转到确认抢购页面
        goToConfirmSnag() {
            // 检查是否登录
            if (!this.isLoggedIn) {
                this.showLoginModal()
                return
            }
            // // 检查点击次数限制
            // const times = this.productData.times || 0
            // const maxTimes = parseInt(this.productData.maxstocktimes) || 0

            // if (times >= maxTimes) {
            //     this.$toast(`You have reached the maximum click limit (${maxTimes} times)`, 3000)
            //     return
            // }
            this.$router.push(`/confirm-snag/${this.$route.params.id}`)
        },
        // 关闭联系管理员弹窗
        closeContactModal() {
            this.showContactAdminModal = false
        },
        //点击购买链接
        async handleLink() {
            // // 检查是否登录
            // if (!this.isLoggedIn) {
            //     this.$toast('Please log in first')
            //     return
            // }

            // // 检查产品数据是否加载
            // if (!this.productData) {
            //     this.$toast('Product info is loading, please wait')
            //     return
            // }

            // // 检查购买链接是否存在
            // if (!this.productData.urllink) {
            //     this.$toast('Purchase link is unavailable')
            //     return
            // }

            // // 检查点击次数限制
            // const times = this.productData.times || 0
            // const maxTimes = parseInt(this.productData.maxstocktimes) || 0

            // if (times >= maxTimes) {
            //     this.$toast(`You have reached the maximum click limit (${maxTimes} times)`, 3000)
            //     return
            // }

            // try {
            //     // 调用更新点击次数接口
            //     const productId = this.$route.params.id
            //     const response = await productApi.updateTimes(productId)

            //     if (response.code === 1) {
            //         // 更新本地点击次数
            //         this.productData.times = times + 1

                    // 跳转到购买链接
                    window.open(this.productData.urllink, '_blank')

            //         this.$toast('Purchase link opened', 2000)
            //     } else {
            //         this.$toast(response.msg || 'Operation failed', 3000)
            //     }
            // } catch (error) {
            //     console.error('Failed to update times:', error)
            //     this.$toast('Operation failed, please try again', 3000)
            // }
        },
        async loadProductDetail() {
            try {
                this.loading = true
                const productId = this.$route.params.id
                const response = await productApi.getProductDetail(productId)

                if (response.code === 1 && response.data) {
                    this.productData = response.data

                    // 更新图片列表
                    if (response.data.images) {
                        const imageUrls = response.data.images.split(',').map(img => {
                            return img.startsWith('http') ? img : `https://houtai5698.koiodeal.com${img}`
                        })
                        this.images = imageUrls
                    }

                    // 更新评论列表
                    if (response.data.comment && response.data.comment.length > 0) {
                        this.reviews = response.data.comment.map(comment => ({
                            id: comment.id,
                            userName: `User ${comment.user_id}`,
                            date: this.formatDate(comment.createtime),
                            rating: parseInt(comment.star) || 5,
                            text: comment.textinfo || '',
                            images: comment.images ? comment.images.split(',').map(img =>
                                img.startsWith('http') ? img : `https://houtai5698.koiodeal.com${img}`
                            ) : []
                        }))
                    } else {
                        this.reviews = []
                    }

                    // 更新收藏状态
                    this.isFavorited = response.data.iscollect === 1
                }
            } catch (error) {
                console.error('Failed to load product detail:', error)
                this.$toast('Failed to load product details, please try again', 3000)
            } finally {
                this.loading = false
            }
        },

        formatDate(timestamp) {
            if (!timestamp) return new Date().toLocaleDateString()
            const date = new Date(timestamp * 1000)
            return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        },

        async loadRelatedProducts() {
            try {
                const formData = new FormData()
                formData.append('page', 1)
                formData.append('count', 5)
                formData.append('order', 1) // 默认排序

                const response = await productApi.getProductList(formData)

                console.log('推荐产品响应:', response)

                if (response.code === 1 && response.data && response.data.list) {
                    // 转换 API 数据格式为组件需要的格式
                    this.relatedProducts = response.data.list.map(item => ({
                        id: item.id,
                        title: item.title,
                        image: item.image.startsWith('http') ? item.image : `https://houtai5698.koiodeal.com${item.image}`,
                        currentPrice: parseFloat(item.price),
                        originalPrice: parseFloat(item.originprice),
                        discount: parseInt(item.discount) || Math.round((1 - parseFloat(item.price) / parseFloat(item.originprice)) * 100),
                        daysLeft: item.etime,
                        stock: item.stock > 0 ? `${item.stock}+` : '10+',
                        isPrime: item.primeswitch === 1,
                        isCollect: item.iscollect === 1,
                        iscollect: item.iscollect
                    }))

                    console.log('推荐产品列表:', this.relatedProducts)
                }
            } catch (error) {
                console.error('Failed to load related products:', error)
            }
        },

        async toggleFavorite() {
            try {
                const productId = this.$route.params.id
                const response = await productApi.setCollect(productId)

                if (response.code === 1) {
                    this.isFavorited = !this.isFavorited
                    this.$toast(this.isFavorited ? 'Added to favorites!' : 'Removed from favorites!')
                } else {
                    this.$toast(response.msg || 'Operation failed', 3000)
                }
            } catch (error) {
                console.error('Failed to toggle favorite:', error)
                this.$toast('Please log in first')
            }
        },
        toggleDescription() {
            this.isDescriptionExpanded = !this.isDescriptionExpanded
        },
        nextImage() {
            if (!this.isLastImage) {
                this.currentImageIndex++
                this.scrollToImage()
            }
        },
        prevImage() {
            if (!this.isFirstImage) {
                this.currentImageIndex--
                this.scrollToImage()
            }
        },
        goToImage(index) {
            this.currentImageIndex = index
            this.scrollToImage()
        },
        scrollToImage() {
            const container = this.$el.querySelector('.fckrYL')
            if (container) {
                const imageWidth = container.offsetWidth
                container.scrollTo({
                    left: imageWidth * this.currentImageIndex,
                    behavior: 'smooth'
                })
            }
        },
        handleKeyPress(e) {
            if (e.key === 'ArrowLeft') {
                this.prevImage()
            } else if (e.key === 'ArrowRight') {
                this.nextImage()
            }
        },
        toggleLinkInput() {
            this.showLinkInput = !this.showLinkInput
        },
        selectAll(event) {
            event.target.select()
        },
        handleTouchStart(e) {
            this.touchStartX = e.touches[0].clientX
            this.touchStartY = e.touches[0].clientY
        },
        handleTouchMove(e) {
            this.touchEndX = e.touches[0].clientX
            this.touchEndY = e.touches[0].clientY
        },
        handleTouchEnd() {
            const deltaX = this.touchEndX - this.touchStartX
            const deltaY = this.touchEndY - this.touchStartY

            // 判断是否为水平滑动(水平距离大于垂直距离)
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                // 设置最小滑动距离阈值为50px
                if (Math.abs(deltaX) > 50) {
                    if (deltaX > 0) {
                        // 向右滑动,显示上一张
                        this.prevImage()
                    } else {
                        // 向左滑动,显示下一张
                        this.nextImage()
                    }
                }
            }

            // 重置触摸位置
            this.touchStartX = 0
            this.touchEndX = 0
            this.touchStartY = 0
            this.touchEndY = 0
        },
        toggleReviews() {
            this.showReviews = !this.showReviews
        },
        setRating(rating) {
            this.newReview.rating = rating
        },
        async handleImageUpload(event) {
            const files = event.target.files
            if (files.length === 0) return

            // 检查是否登录
            if (!this.isLoggedIn) {
                this.$toast('Please log in to upload images')
                return
            }

            try {
                for (let i = 0; i < files.length; i++) {
                    const file = files[i]

                    if (!file.type.startsWith('image/')) {
                        this.$toast('Only image files are allowed')
                        continue
                    }

                    if (file.size > 5 * 1024 * 1024) {
                        this.$toast('Image size cannot exceed 5MB')
                        continue
                    }

                    // 显示预览（使用 FileReader）
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        this.newReview.images.push(e.target.result)
                    }
                    reader.readAsDataURL(file)

                    // 上传到服务器
                    try {
                        const response = await commonApi.uploadImage(file)

                        if (response.code === 1 && response.data) {
                            let imagePath = ''

                            if (typeof response.data === 'object') {
                                imagePath = response.data.imgsrc || response.data.imgSrc || ''
                            } else if (typeof response.data === 'string') {
                                imagePath = response.data
                            }

                            if (imagePath) {
                                this.newReview.uploadedImageUrls.push(imagePath)
                            } else {
                                console.error('Failed to get image path:', response.data)
                                this.$toast('Image upload failed: unable to get image path')
                                const index = this.newReview.images.length - 1
                                if (index >= 0) this.newReview.images.splice(index, 1)
                            }
                        } else {
                            this.$toast('Image upload failed: ' + (response.msg || 'Unknown error'))
                            const index = this.newReview.images.length - 1
                            if (index >= 0) this.newReview.images.splice(index, 1)
                        }
                    } catch (error) {
                        console.error('Image upload failed:', error)
                        this.$toast('Image upload failed, please try again')
                        const index = this.newReview.images.length - 1
                        if (index >= 0) this.newReview.images.splice(index, 1)
                    }
                }
            } catch (error) {
                console.error('Failed to process images:', error)
                this.$toast('Failed to process images')
            }

            // 清空 input，允许重复选择同一文件
            event.target.value = ''
        },
        removeImage(index) {
            this.newReview.images.splice(index, 1)
            this.newReview.uploadedImageUrls.splice(index, 1)
        },
        async submitReview() {
            if (this.newReview.rating === 0) {
                this.$toast('Please select a rating')
                return
            }
            if (!this.newReview.text.trim()) {
                this.$toast('Please enter your review')
                return
            }

            try {
                const productId = this.$route.params.id

                // 准备表单数据
                const formData = new FormData()
                formData.append('product_id', productId)
                formData.append('textinfo', this.newReview.text)
                formData.append('star', this.newReview.rating)

                // 如果有上传的图片，使用服务器返回的URL
                if (this.newReview.uploadedImageUrls.length > 0) {
                    formData.append('images', this.newReview.uploadedImageUrls.join(','))
                }

                const response = await productApi.addComment(formData)

                if (response.code === 1) {
                    // 添加新评论到列表
                    // const review = {
                    //     id: response.data?.id || Date.now(),
                    //     userName: 'Current User',
                    //     date: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
                    //     rating: this.newReview.rating,
                    //     text: this.newReview.text,
                    //     images: [...this.newReview.uploadedImageUrls]
                    // }
                    // this.reviews.unshift(review)
                    await this.loadProductDetail()
                    // 重置表单
                    this.newReview = {
                        rating: 0,
                        text: '',
                        images: [],
                        uploadedImageUrls: []
                    }

                    // 显示评论列表
                    this.showReviews = true

                    this.$toast('Review submitted successfully!')
                } else {
                    this.$toast(response.msg || 'Review submission failed', 3000)
                }
            } catch (error) {
                console.error('Failed to submit review:', error)
                this.$toast('Please log in to leave a review')
            }
        },
        openImagePreview(img) {
            window.open(img, '_blank')
        },
        openImageModal(img) {
            // 可以在这里实现图片放大查看功能
            window.open(img, '_blank')
        },
        showLoginModal() {
            // 触发显示登录弹窗
            this.$root.$emit('show-favorite-modal')
        }
    }
}
</script>
<style scoped>
.hvoxeo {
    margin: auto;
    padding: 30px 0px;
    width: 100%;
}

.diEiwz {
    margin-bottom: 20px;
}

.dzlHoR {
    background: rgb(255, 255, 255);
    border-radius: 8.5px;
    color: rgb(0, 0, 0);
    margin: auto;
    padding: 100px;
    position: relative;
    width: 100%;
}

.fNhWMg {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 1;
}

.NinWN {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
}

.kOIKqN {
    cursor: pointer;
    width: 24px;
}

.yEigr {
    fill: rgba(0, 0, 0, 0);
    stroke: rgb(0, 0, 0);
    stroke-width: 5px;
    transition: all 0.3s ease;
}

.yEigr:hover {
    fill: rgba(0, 0, 0, 0.2);
    stroke: #000;
}

.yEigr2 {
    fill: #000;
    stroke: #000;
    stroke-width: 3px;
    transition: all 0.3s ease;
}

.yEigr2:hover {
    fill: #000;
    stroke: #000;
}

.fNhWMg {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 1;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.fNhWMg:hover {
    transform: scale(1.15);
}

.fNhWMg:active {
    transform: scale(0.95);
}

.yEigr2 {
    fill: rgba(0, 0, 0, 1);
    stroke: rgb(0, 0, 0);
    stroke-width: 5px;
}

.kzmGcl {
    position: relative;
}

.fckrYL {
    display: flex;
    height: 100%;
    overflow: scroll hidden;
    scroll-snap-type: x mandatory;
    width: 100%;
    overflow: hidden;
}

.jXdwPZ {
    display: flex;
    flex: 0 0 100%;
    -webkit-box-pack: center;
    justify-content: center;
    margin: auto 10px;
    scroll-snap-align: start;
    scroll-snap-stop: always;
}

.hMFySe {
    margin: 5px;
    max-height: 100%;
    max-width: 100%;
    min-height: 400px;
}

.btSFVV {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    font-size: 26px;
    height: 100%;
    -webkit-box-pack: justify;
    justify-content: space-between;
    position: absolute;
    width: 100%;
}

.btSFVV div {
    -webkit-box-align: center;
    align-items: center;
    background: white;
    border-radius: 50%;
    box-shadow: transparent 0px 0px 0px 1px, transparent 0px 0px 0px 4px, rgba(0, 0, 0, 0.18) 0px 2px 4px;
    cursor: pointer;
    display: flex;
    height: 34px;
    -webkit-box-pack: center;
    justify-content: center;
    width: 34px;
}

.btSFVV div.noShow {
    background: unset;
    box-shadow: unset;
    cursor: unset;
}

.btSFVV div.noShow i {
    visibility: hidden;
}

.btSFVV div i {
    font-size: 22px;
    padding-top: 3px;
}

.jxDVvh {
    align-items: flex-end;
    display: flex;
    height: 100%;
    -webkit-box-pack: end;
    justify-content: flex-end;
    pointer-events: none;
    position: absolute;
    right: 0px;
}

.jxDVvh div {
    background: rgba(34, 34, 34, 0.66);
    border-radius: 4px;
    bottom: 10px;
    color: white;
    font-size: 14px;
    margin-bottom: 15px;
    margin-right: 15px;
    padding: 3px 10px;
}

.fPkgfg {
    display: flex;
    margin: 20px 0px;
    overflow: scroll hidden;
    scroll-snap-type: x mandatory;
    width: 100%;
}

.juqvNl {
    border: 2px solid rgba(0, 0, 0, 0);
    cursor: pointer;
    display: flex;
    height: 94px;
    -webkit-box-pack: center;
    justify-content: center;
    margin: auto 10px;
    scroll-snap-align: start;
    width: 94px;
}

.gCrnRY {
    margin: 5px;
    max-height: 80px;
    max-width: 80px;
}

/* 两栏布局 */
.product-container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

.product-detail-row {
    display: flex;
    gap: 30px;
    margin: 0;
    align-items: flex-start;
}

.product-image-col {
    flex: 0 0 45%;
    max-width: 45%;
    padding: 0;
}

.product-info-col {
    flex: 0 0 55%;
    max-width: 55%;
    padding: 0;
}

/* 缩略图样式 */
.fPkgfg {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    overflow-x: auto;
    padding: 10px 0;
    overflow: hidden;
}

.juqvNl {
    flex: 0 0 auto;
    width: 80px;
    height: 80px;
    border: 2px solid transparent;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
}

.juqvNl:hover {
    border-color: #ddd;
    transform: scale(1.05);
}

.juqvNl.active {
    border: 2px solid rgb(238, 238, 238);
}

.juqvNl:hover {
    border: 2px solid rgb(238, 238, 238);
}

.gCrnRY {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.NJgzn {
    align-items: flex-start;
    display: flex;
    flex-flow: column;
    padding-top: 15px;
}

.NJgzn .retail-price {
    color: rgb(191, 191, 191);
    font-size: 24px;
    position: relative;
    text-decoration: line-through;
}

.hxWNLV {
    margin-right: 25px;
}

.gTkNMg {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex-flow: wrap;
    padding-top: 1.875rem;
}

.fcmNQk {
    padding-top: 1rem;
}

.gTkNMg {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex-flow: wrap;
    padding-top: 1.875rem;
}

.lbhUOd {
    -webkit-box-align: center;
    align-items: center;
    color: rgb(51, 51, 51);
    display: flex;
    font-size: 16px;
    font-weight: bold;
    height: 20px;
}

.cSPCYd {
    margin-right: 4px;
}

.gBwkYC {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex-flow: wrap;
    padding: 20px 0px 25px;
    text-align: center;
}

.izpgKW {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    padding: 10px 0px;
}

.cGxNOm {
    height: 19px;
    width: 30px;
}

.ggmeuU {
    height: 19px;
    width: 24px;
}

.jyQHCJ {
    height: 24px;
    width: 24px;
}

.fHsNUo {
    height: 24px;
    width: 24px;
}

.gzqtwP {
    height: 24px;
    fill: rgb(165, 165, 165);
    width: 24px;
}

.dvuMXO {
    color: rgb(165, 165, 165);
    font-size: 20px;
    padding: 0px 25px 0px 10px;
}

.kduZGZ {
    background: rgb(0, 0, 0);
    border-width: 1px;
    border-style: solid;
    border-color: rgb(255, 255, 255);
    border-radius: 35px;
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: inline-flex;
    font-size: 18px;
    font-weight: 600;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 12px 60px;
    text-align: center;
    width: 100%;
}

.eppWtj {
    max-width: 600px;
}

.hgRRyp {
    -webkit-box-align: center;
    align-items: center;
    background: rgb(255, 255, 255);
    border: 2px solid;
    border-radius: 50%;
    color: rgb(226, 226, 226);
    display: flex;
    height: 52px;
    min-width: 52px;
    -webkit-box-pack: center;
    justify-content: center;
    margin: 0px 0px 0px 15px;
    padding: 10px;
    width: 52px;
}

.hNxRHe {
    max-height: 100%;
}

.hwPjrI {
    color: rgb(56, 56, 56);
}

.eSybho {
    -webkit-box-align: center;
    align-items: center;
    color: rgb(165, 165, 165);
    display: flex;
    font-size: 1.25rem;
    padding: 1.875rem 0px;
}

.section-header {
    font-size: 30px;
    margin: 0;
    padding: 15px 0;
    text-align: center;
}

.eELPGX {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding-top: 50px;
    margin: 0 auto;
}

.dDUrGZ {
    color: rgb(0, 0, 0);
    font-size: 1.5625rem;
    font-weight: 500;
}

.fwrjDL {
    border: 4px solid rgb(255, 194, 0);
    border-radius: 5px;
    width: 45px;
}

/* Read more 按钮样式 */
.read-more-btns {
    color: #00a8e8;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 5px;
}

.read-more-btns:hover {
    color: #0086b8;
}

@media (min-width: 1367px) {
    .hvoxeo {
        max-width: 1700px;
        width: 92%;
    }
}

@media (max-width: 1366px) {
    .hvoxeo {
        width: 94%;
    }

    .diEiwz {
        padding: 80px;
    }
}

@media (max-width: 1024px) {
    .hvoxeo {
        padding: 30px;
    }

    .diEiwz {
        padding: 40px 80px;
    }

    .product-detail-row {
        flex-direction: column;
        gap: 20px;
    }

    .product-image-col,
    .product-info-col {
        flex: 0 0 100%;
        max-width: 100%;
    }
}

/* 评论区域样式 */
.review-section {
    width: 100%;
    background: white;
    border-radius: 8.5px;
    padding: 40px;
    margin-top: 30px;
}

.review-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
}

.review-title {
    font-size: 28px;
    font-weight: 600;
    color: #000;
    margin: 0;
}

.review-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #666;
    font-size: 16px;
    transition: color 0.3s;
}

.review-toggle:hover {
    color: #000;
}

.review-toggle i {
    font-size: 20px;
}

/* 评论列表 */
.reviews-list {
    margin-bottom: 40px;
}

.no-reviews {
    text-align: center;
    padding: 60px 20px;
    color: #999;
}

.no-reviews p {
    font-size: 16px;
    margin: 0;
}

.review-item {
    padding: 25px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-bottom: 20px;
    background: #fafafa;
}

.review-user-info {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
}

.user-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #ff0000;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
}

.user-details {
    flex: 1;
}

.user-name {
    font-size: 18px;
    font-weight: 600;
    color: #000;
}

.review-date {
    font-size: 14px;
    color: #999;
    margin-top: 4px;
}

.review-rating {
    margin-bottom: 15px;
}

.review-rating i {
    font-size: 18px;
    margin-right: 4px;
}

.star-filled {
    color: #ffc107;
}

.star-empty {
    color: #e0e0e0;
}

.review-text {
    font-size: 16px;
    line-height: 1.6;
    color: #333;
    margin-bottom: 15px;
}

.review-images {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.review-image {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.3s;
}

.review-image:hover {
    transform: scale(1.05);
}

/* 添加评论表单 */
.add-review-section {
    padding: 30px;
    background: #f9f9f9;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
}

.add-review-title {
    font-size: 22px;
    font-weight: 600;
    color: #000;
    margin-bottom: 25px;
}

.rating-input {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 25px;
}

.rating-label {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

.star-rating {
    display: flex;
    gap: 5px;
}

.star-rating i {
    font-size: 28px;
    cursor: pointer;
    transition: all 0.2s;
}

.star-rating i:hover {
    transform: scale(1.2);
}

.review-textarea {
    width: 100%;
    padding: 15px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 8px;
    resize: vertical;
    font-family: inherit;
}

.review-textarea:focus {
    outline: none;
    border-color: #000;
}

.image-upload-area {
    margin-top: 10px;
}

.btn-upload-image {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 24px;
    background: white;
    border: 2px dashed #ddd;
    border-radius: 8px;
    color: #666;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
}

.btn-upload-image:hover {
    border-color: #000;
    color: #000;
}

.btn-upload-image i {
    font-size: 20px;
}

.preview-images {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    margin-top: 20px;
}

.preview-image-wrapper {
    position: relative;
    width: 100px;
    height: 100px;
}

.preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    border: 2px solid #ddd;
}

.btn-remove-image {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ff0000;
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: transform 0.2s;
}

.btn-remove-image:hover {
    transform: scale(1.1);
}

.btn-submit-review {
    margin-top: 25px;
    padding: 14px 40px;
    background: #000;
    color: white;
    border: none;
    border-radius: 35px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
}

.btn-submit-review:hover {
    background: #333;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* 联系管理员弹窗 */
.contact-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(2px);
}

.contact-box {
    width: 100%;
    max-width: 460px;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);
    overflow: hidden;
}

.contact-box-header {
    background: linear-gradient(135deg, #1a1a1a 0%, #3a3a3a 100%);
    color: #fff;
    padding: 22px 24px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.contact-box-icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: rgba(255, 162, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.contact-box-icon .fa {
    font-size: 17px;
    color: #ffa200;
}

.contact-box-title {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.3px;
    margin: 0;
    flex: 1;
    color: #fff;
}

.close-btn {
    background: rgba(255, 255, 255, 0.12);
    border: none;
    color: #fff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
    font-size: 13px;
    padding: 0;
    flex-shrink: 0;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.28);
}

.contact-box-body {
    padding: 26px 24px 18px;
    background: #fff;
}

.info-text {
    font-size: 14px;
    color: #888;
    margin: 0 0 18px;
    text-align: center;
}

.contact-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 15px 18px;
    border-radius: 12px;
    background: #f8f8f8;
    margin-bottom: 10px;
    transition: background 0.2s, transform 0.2s;
}

.contact-item:last-child {
    margin-bottom: 0;
}

.contact-item:hover {
    background: #fff4e0;
    transform: translateX(3px);
}

.contact-item .fa {
    font-size: 18px;
    color: #ffa200;
    width: 22px;
    text-align: center;
    flex-shrink: 0;
}

.contact-label {
    font-size: 12px;
    color: #aaa;
    font-weight: 500;
    flex-shrink: 0;
    width: 54px;
}

.contact-value {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    text-decoration: none;
    flex: 1;
    word-break: break-all;
}

.contact-value:hover {
    color: #ffa200;
}

.contact-box-footer {
    padding: 14px 24px 22px;
    border-top: 1px solid #f2f2f2;
    display: flex;
    justify-content: center;
    background: #fff;
}

.btn-close-modal {
    padding: 11px 44px;
    background: #1a1a1a;
    color: #fff;
    border: none;
    border-radius: 30px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s;
    letter-spacing: 0.5px;
}

.btn-close-modal:hover {
    background: #ffa200;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 162, 0, 0.35);
}

.contact-modal-enter-active,
.contact-modal-leave-active {
    transition: opacity 0.25s ease;
}

.contact-modal-enter-active .contact-box,
.contact-modal-leave-active .contact-box {
    transition: transform 0.25s ease, opacity 0.25s ease;
}

.contact-modal-enter,
.contact-modal-leave-to {
    opacity: 0;
}

.contact-modal-enter .contact-box,
.contact-modal-leave-to .contact-box {
    opacity: 0;
    transform: scale(0.92) translateY(-10px);
}

/* 过渡动画 */
.slide-fade-enter-active {
    transition: all 0.4s ease;
}

.slide-fade-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-enter-from {
    transform: translateY(-20px);
    opacity: 0;
}

.slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
}

@media (max-width: 767px) {
    .hvoxeo {
        padding: 0px 5px 40px;
        width: 96%;
        overflow-x: hidden;
    }

    .review-section {
        padding: 20px;
        margin-top: 20px;
    }
    .hMFySe {
        min-height: 250px;
    }
    .review-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }

    .review-title {
        font-size: 22px;
    }

    .review-item {
        padding: 15px;
    }

    .user-avatar {
        width: 40px;
        height: 40px;
        font-size: 16px;
    }

    .user-name {
        font-size: 16px;
    }

    .review-text {
        font-size: 14px;
    }

    .add-review-section {
        padding: 20px;
    }

    .add-review-title {
        font-size: 18px;
    }

    .rating-input {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .star-rating i {
        font-size: 24px;
    }

    .btn-submit-review {
        width: 100%;
        padding: 12px 20px;
        font-size: 16px;
    }

    .diEiwz {
        padding: 20px;
        overflow-x: hidden;
    }

    .dzlHoR {
        padding: 40px 20px;
        overflow-x: hidden;
    }

    .product-container {
        overflow-x: hidden;
        width: 100%;
    }

    .product-detail-row {
        overflow-x: hidden;
        width: 100%;
    }

    .product-image-col,
    .product-info-col {
        overflow-x: hidden;
        width: 100%;
        max-width: 100%;
    }

    .fNhWMg {
        background: white;
        border-radius: 50%;
        box-shadow: transparent 0px 0px 0px 1px, transparent 0px 0px 0px 4px, rgba(0, 0, 0, 0.18) 0px 2px 4px;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        height: 29px;
        padding: 5px;
        right: 10px;
        top: 12px;
        width: 29px;
    }

    .kOIKqN {
        width: 21px;
    }

    .btSFVV {
        display: none;
    }

    .fPkgfg {
        display: none;
    }

    .lbhUOd {
        font-size: 14px;
    }

    .cSPCYd {
        width: 17px;
    }

    .izpgKW {
        width: 100%;
    }

    .eppWtj,
    .hgRRyp {
        font-size: 14px !important;
        padding: 10px 15px !important;
        white-space: nowrap;
    }

    .product-name {
        font-size: 1.3rem !important;
        line-height: 1.4;
    }

    .eSybho {
        flex-wrap: wrap;
        font-size: 1rem;
        padding: 1rem 0;
    }

    .eSybho span {
        flex-wrap: wrap;
    }

    #react-container {
        overflow-x: hidden;
        width: 100%;
    }

    #react-container>div {
        overflow-x: hidden;
        width: 100%;
    }

}

@media (max-width: 767px) {
    .review-section {
        padding: 20px;
        margin-top: 20px;
    }

    .review-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }

    .review-title {
        font-size: 22px;
    }

    .review-item {
        padding: 15px;
    }

    .user-avatar {
        width: 40px;
        height: 40px;
        font-size: 16px;
    }

    .user-name {
        font-size: 16px;
    }

    .review-text {
        font-size: 14px;
    }

    .add-review-section {
        padding: 20px;
    }

    .add-review-title {
        font-size: 18px;
    }

    .rating-input {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .star-rating i {
        font-size: 24px;
    }

    .btn-submit-review {
        width: 100%;
        padding: 12px 20px;
        font-size: 16px;
    }
}
</style>
